import {
    faEllipsisV,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef } from 'react';

const ChartMenuCustomToggle = forwardRef(({ children, onClick }, ref) => (
    <span
        className="cursor-pointer px-4"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick(e);
        }}
    >
        {children}
        <FontAwesomeIcon size="lg" className="mt-3" icon={faEllipsisV} />
    </span>
));

ChartMenuCustomToggle.displayName = 'ChartMenuCustomToggle';

export default ChartMenuCustomToggle;
